import { render, staticRenderFns } from "./PeopleManagement.vue?vue&type=template&id=b0366ada&scoped=true&"
import script from "./PeopleManagement.vue?vue&type=script&lang=js&"
export * from "./PeopleManagement.vue?vue&type=script&lang=js&"
import style0 from "./PeopleManagement.vue?vue&type=style&index=0&id=b0366ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0366ada",
  null
  
)

export default component.exports